import React from "react"

import PropTypes from "prop-types"
import classNames from "classnames"
import Card from "../../../layout/card"

import CareTypeSpecificLinks from "../care_type_specific_links"
import {
  alternativeCareType,
  imgContainer,
  overallPadding,
} from "./styles.module.scss"
import { SubTitle } from "../../../Typography/Typography"
import StaticImage from "../../../StaticImage"

const careTypeHeading = (careType) =>
  careType
    ? "Looking for a different type of care?"
    : "What type of care are you looking for?"

const AlternativeCareTypeCard = ({ careType }) => (
  <Card
    noPadding
    noMarginAbove
    noMarginBelow
    extraClasses={classNames(alternativeCareType)}
  >
    {careType === "care_home" && (
      <StaticImage
        name="alternative_care_type_care_home"
        className={imgContainer}
      />
    )}
    {careType !== "care_home" && (
      <StaticImage name="care_type_default" className={imgContainer} />
    )}
    <SubTitle className={overallPadding}>{careTypeHeading(careType)}</SubTitle>
    <CareTypeSpecificLinks />
  </Card>
)

export default AlternativeCareTypeCard

AlternativeCareTypeCard.propTypes = {
  careType: PropTypes.oneOf(["home_care", "care_home"]),
}

AlternativeCareTypeCard.defaultProps = {
  careType: undefined,
}
